import { github, SyntaxHighlighter } from '../../lib/react-syntax-highlighter';
import React, { HTMLProps, useEffect, useRef } from 'react';

import block from 'propmods';

import { editor } from '../../lib/monaco';
import { Page } from '../Typo/Typo';

import './DocumentationTypo.scss';

const b = block('DocumentationTypo');

const Paragraph: React.FC<HTMLProps<HTMLParagraphElement>> = (props) => {
    return <div {...b('paragraph')} {...props} />;
};

const H1: React.FC<HTMLProps<HTMLHeadingElement>> = (props) => {
    return <h1 {...b('h1')} {...props} />;
};

const H2: React.FC<HTMLProps<HTMLHeadingElement>> = (props) => {
    return <h2 {...b('h2')} {...props} />;
};

const H3: React.FC<HTMLProps<HTMLHeadingElement>> = (props) => {
    return <h3 {...b('h3')} {...props} />;
};

interface AnchorProps {
    to: string;
}

const Anchor: React.FC<AnchorProps> = ({ to, children }) => {
    return (
        <a {...b('anchor')} href={`#${to}`}>
            {children}
        </a>
    );
};

const UnorderedList: React.FC = (props) => {
    return <ul {...props} {...b('ul')} />;
};

const OrderedList: React.FC = (props) => {
    return <ol {...props} {...b('ol')} />;
};

const GranetSyntaxHighlighter: React.FC<{ children: string }> = ({ children }) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        editor
            .colorize(children, 'granet', {})
            .then((result) => (ref.current!.innerHTML = result))
            .catch(console.error);
    });

    return (
        <div {...b('granet-syntax')} ref={ref}>
            {children}
        </div>
    );
};

interface GrammarSyntaxHighlighterProps {
    type: 'granet' | 'json';
    children: string;
}

const CodeBlock: React.FC<GrammarSyntaxHighlighterProps> = ({ children, type }) => {
    return (
        <div {...b('code-block')}>
            {(() => {
                switch (type) {
                    case 'granet':
                        return <GranetSyntaxHighlighter>{children}</GranetSyntaxHighlighter>;
                    case 'json':
                        return (
                            <SyntaxHighlighter language="json" style={github}>
                                {children}
                            </SyntaxHighlighter>
                        );
                }
            })()}
        </div>
    );
};

const CodeBlockInline: React.FC = ({ children }) => {
    return <code {...b('code-block-inline')}>{children}</code>;
};

const DocPage: React.FC = ({ children }) => {
    return (
        <div {...b('doc-page')}>
            <Page.Page>
                <div {...b('doc-page-main')}>{children}</div>
            </Page.Page>
        </div>
    );
};

export const DocumentationTypo = {
    H1,
    H2,
    H3,
    Anchor,
    UnorderedList,
    OrderedList,
    CodeBlock,
    CodeBlockInline,
    Paragraph,
    DocPage,
};
